import display from '../utilities/display';
import flex from '../utilities/flex';

export default {...display.dInlineFlex, ...flex.alignItemsBaseline};
